var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats-container" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", { staticClass: "stats-card" }, [
                    _c("div", { staticClass: "stats-content" }, [
                      _c("div", { staticClass: "stats-icon success" }, [
                        _c("i", { staticClass: "el-icon-success" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stats-info" }, [
                        _c("div", { staticClass: "stats-number" }, [
                          _vm._v(_vm._s(_vm.statistics.successCount || 0)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "stats-label" }, [
                          _vm._v("同步成功"),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", { staticClass: "stats-card" }, [
                    _c("div", { staticClass: "stats-content" }, [
                      _c("div", { staticClass: "stats-icon warning" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stats-info" }, [
                        _c("div", { staticClass: "stats-number" }, [
                          _vm._v(_vm._s(_vm.statistics.runningCount || 0)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "stats-label" }, [
                          _vm._v("同步中"),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", { staticClass: "stats-card" }, [
                    _c("div", { staticClass: "stats-content" }, [
                      _c("div", { staticClass: "stats-icon danger" }, [
                        _c("i", { staticClass: "el-icon-error" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stats-info" }, [
                        _c("div", { staticClass: "stats-number" }, [
                          _vm._v(_vm._s(_vm.statistics.failedCount || 0)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "stats-label" }, [
                          _vm._v("同步失败"),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", { staticClass: "stats-card" }, [
                    _c("div", { staticClass: "stats-content" }, [
                      _c("div", { staticClass: "stats-icon info" }, [
                        _c("i", { staticClass: "el-icon-time" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stats-info" }, [
                        _c("div", { staticClass: "stats-number" }, [
                          _vm._v(_vm._s(_vm.statistics.totalCount || 0)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "stats-label" }, [
                          _vm._v("总同步次数"),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sync-actions" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c(
              "div",
              {
                staticClass: "card-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("快速同步")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "action-buttons" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-refresh",
                      loading: _vm.syncLoading.business,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSync("business")
                      },
                    },
                  },
                  [_vm._v("\n          同步商户数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      icon: "el-icon-refresh",
                      loading: _vm.syncLoading.store,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSync("store")
                      },
                    },
                  },
                  [_vm._v("\n          同步门店数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      icon: "el-icon-refresh",
                      loading: _vm.syncLoading.full,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSync("full")
                      },
                    },
                  },
                  [_vm._v("\n          全量同步\n        ")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-card",
            { staticClass: "filter-card", attrs: { shadow: "never" } },
            [
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    model: _vm.queryParams,
                    size: "small",
                    inline: true,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "同步类型", prop: "syncType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: {
                            placeholder: "请选择同步类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.syncType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "syncType", $$v)
                            },
                            expression: "queryParams.syncType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "商户同步", value: "business" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "门店同步", value: "store" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "全量同步", value: "full" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "同步方式", prop: "syncMethod" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: {
                            placeholder: "请选择同步方式",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.syncMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "syncMethod", $$v)
                            },
                            expression: "queryParams.syncMethod",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "手动同步", value: "manual" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "定时同步", value: "scheduled" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "同步状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: {
                            placeholder: "请选择同步状态",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "同步中", value: "running" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "同步成功", value: "success" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "同步失败", value: "failed" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "同步时间" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "350px" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleQuery },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh" },
                          on: { click: _vm.resetQuery },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("同步记录")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "text",
                    icon: "el-icon-refresh",
                  },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.syncLogList, stripe: "", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "同步类型",
                  prop: "syncType",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getSyncTypeTagType(scope.row.syncType),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getSyncTypeText(scope.row.syncType)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "同步方式",
                  prop: "syncMethod",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.syncMethod === "manual"
                                  ? "warning"
                                  : "info",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.syncMethod === "manual"
                                    ? "手动"
                                    : "定时"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "同步状态",
                  prop: "status",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTagType(scope.row.status),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getStatusText(scope.row.status)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "总记录数",
                  prop: "totalCount",
                  width: "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "成功数",
                  prop: "successCount",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "success-count": scope.row.successCount > 0,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.successCount) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "失败数",
                  prop: "failedCount",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "failed-count": scope.row.failedCount > 0,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.failedCount) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "成功率", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: _vm.getSuccessRateClass(scope.row) },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getSuccessRate(scope.row)) +
                                "%\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "同步时间",
                  prop: "createTime",
                  width: "160",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "text",
                              icon: "el-icon-view",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            详情\n          ")]
                        ),
                        _vm._v(" "),
                        scope.row.status === "failed"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "text",
                                  icon: "el-icon-refresh",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRetry(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            重试\n          ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.pageNum,
              limit: _vm.queryParams.pageSize,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "pageNum", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("sync-detail", { ref: "syncDetail" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "page-title" }, [
        _c("i", { staticClass: "el-icon-refresh" }),
        _vm._v("\n      数据同步管理\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-desc" }, [
        _vm._v("管理商户和门店数据的同步任务"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }